import Vue from 'vue';
import $ from 'jquery';
import 'jquery-mask-plugin';

function aplicarMascara(el, binding) {
  const mascara = binding.value;

  const nonoDigito = function (val) {
    return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
  };

  const aplicaNonoDigito = {
    clearIfNotMatch: true,
    onKeyPress: function (val, e, field, options) {
      field.mask(nonoDigito.apply({}, arguments), options);
    }
  };

  if (mascara === 'data') {
    $(`#${el.id}`).mask('00/00/0000', { clearIfNotMatch: true });
  } else if (mascara === 'data-mask') {
    $(`#${el.id}`).find('input').mask('00/00/0000', {clearIfNotMatch: true});
  } else if (mascara === 'mes-ano') {
    $(`#${el.id}`).mask('00/0000', { clearIfNotMatch: true });
  } else if (mascara === 'hora') {
    $(`#${el.id}`).mask('00:00', { clearIfNotMatch: true });
  } else if (mascara === 'cep') {
    $(`#${el.id}`).mask('00000-000', { clearIfNotMatch: true });
  } else if (mascara === 'cnpj') {
    $(`#${el.id}`).mask('00.000.000/0000-00', { clearIfNotMatch: true });
  } else if (mascara === 'telefone') {
    $(`#${el.id}`).mask(nonoDigito, aplicaNonoDigito);
  } else if (mascara === 'cpf') {
    $(`#${el.id}`).mask('000.000.000-00', {clearIfNotMatch: true});
  } else if (mascara === 'inss' || mascara === 'pispasep') {
    $(`#${el.id}`).mask('000.00000.00/0', { clearIfNotMatch: true });
  } else if (mascara === 'moeda') {
    $(`#${el.id}`).mask('000.000.000,00', {
      reverse: true
    });
  } else if (mascara === 'moedaImportacao') {
    $(`#${el.id}`).mask('000.000.000,00000', {
      reverse: true
    });
  } else if (mascara === 'porcentagem') {
    $(`#${el.id}`).mask('000,00', {
      reverse: true
    });
  } else if (mascara === 'numero') {
    $(`#${el.id}`).mask('00000000', {
      reverse: true
    });
  } else if (mascara !== '') {
    $(`#${el.id}`).mask(mascara, { clearIfNotMatch: true });
  } else {
    removerEventos(el);
    $(`#${el.id}`).removeAttr('maxlength');
    
    return;
  }

  $(`#${el.id}`)
    .on('keyup.mask blur.mask focusout.mask', function(ev) {
      let inputEvent = new Event('input');
      ev.target.dispatchEvent(inputEvent);
    });
}

function removerEventos(el) {
  $(`#${el.id}`)
    .off('input.mask keydown.mask keyup.mask paste.mask drop.mask change.mask blur.mask focus.mask focusout.mask');
}

Vue.directive('mascara', {
  bind: aplicarMascara,
  update: aplicarMascara,
  unbind: removerEventos
});



// WEBPACK FOOTER //
// ./FrontEnd/diretivas/mascara.js